import { render, staticRenderFns } from "./ClinicalHandouts.vue?vue&type=template&id=08537c4b"
import script from "./ClinicalHandouts.vue?vue&type=script&lang=js"
export * from "./ClinicalHandouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports